import clsx from "clsx";
import React, { forwardRef } from "react";
import { IconButton, IconClose, Label } from "@trainline/depot-web";
import dayjs from "../../../../utils/dayjs";
import * as styles from "./InputToggleCondensed.module.css";
const formatValue = (value, withTime) => value ? dayjs(value).format(withTime ? "ddd D MMM [\u2022] LT" : "ddd D MMM YYYY") : "";
const InputToggleCondensed = ({ id, className, style, label, clearLabel, onClear, withTime = true, ...props }, forwardedRef) => {
  const isEmpty = !props.value;
  const isClearable = !!onClear;
  const inputId = `${id}-input-toggle`;
  const labelId = `${id}-input-toggle-label`;
  return /* @__PURE__ */ React.createElement("div", {
    style,
    className: clsx(styles.root, className),
    "data-invalid": props["aria-invalid"],
    "data-current": props["aria-current"]
  }, /* @__PURE__ */ React.createElement(Label, {
    typeStyle: "body",
    color: "subtle",
    "aria-hidden": isEmpty,
    id: labelId,
    htmlFor: inputId
  }, label), /* @__PURE__ */ React.createElement("input", {
    ...props,
    "aria-labelledby": labelId,
    ref: forwardedRef,
    id: inputId,
    type: "text",
    readOnly: true,
    role: "button",
    value: formatValue(props.value, withTime)
  }), isClearable && /* @__PURE__ */ React.createElement(IconButton, {
    onClick: (e) => {
      e.preventDefault();
      e.stopPropagation();
      onClear(e);
    },
    type: "button",
    size: "small",
    icon: IconClose,
    "aria-label": clearLabel,
    "aria-hidden": isEmpty
  }));
};
var InputToggleCondensed_default = forwardRef(InputToggleCondensed);
export {
  InputToggleCondensed,
  InputToggleCondensed_default as default
};
